//
//
//
//
//
//

import { EventBus } from "@/common/eventbus";
import SvgAll from './common/components/SvgAll.vue';

export default {
    components: {
        SvgAll
    },
    data(){
        return {
            currentLoadingNum: 0
        };
    },
    methods: {

    },
    beforeDestroy(){
        EventBus.$off('showLoading');
        EventBus.$off('hideLoading');
    },
    created() {
        //开启loading
        EventBus.$on('showLoading', () => {
            this.currentLoadingNum++;
            if (this.$route.name === 'home') {//首页不展示loading
                this.currentLoadingNum = 0;
            }
            // if (this.currentLoadingNum > 0) {
            //     this.$vux.loading.show({
            //         text: '',
            //         transition: 'vux-mask',
            //     });
            // }
        });
        //隐藏loading
        EventBus.$on('hideLoading', () => {
            this.currentLoadingNum--;
            if(this.$route.name === 'home') {//首页隐藏loading
                this.currentLoadingNum = 0;
            }
            if(this.currentLoadingNum <= 0){
                this.$vux.loading.hide();
            }
        });
    }
};
